export enum LicensedProductsEnum {
  Core = 'core',
  Ledger = 'ledger',
  Warehouse = 'warehouse'
}

export type LicensedProducts = {
  [LicensedProductsEnum.Core]: boolean;
  [LicensedProductsEnum.Warehouse]?: boolean;
  [LicensedProductsEnum.Ledger]?: boolean;
};
